import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { MaintenanceProvider } from "./context/MaintenanceContext";
import { PushNotificationProvider } from "./context/PushNotificationContext";
import { PWAInstallProvider } from "./context/PWAInstallContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <MaintenanceProvider>
        <PWAInstallProvider>
          <PushNotificationProvider>
            <App />
          </PushNotificationProvider>
        </PWAInstallProvider>
      </MaintenanceProvider>
    </AuthProvider>
  </React.StrictMode>,
);

// Register service worker for PWA support across all routes (including /login)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.log("Service worker registration failed:", err);
    });
  });
}

reportWebVitals();
